import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";

export default function CssfPdfBusinessSkillsSection( { resumeData } ) {
    const { businessSkills } = extractResumeDataDocumentSection( resumeData );
    const documentLanguage = 'fr'; // Forced for CSSF

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 10,
            fontSize: 10,
        },
        textStart: {
            textAlign: 'start',
        },
        leftColumn: {
            width: '16%',
        },
        rightColumn: {
            width: '80%',
            marginLeft: 12,
        },
    } );


    return (
        <>
            <View key="title" style={ [ styles.section, { marginBottom: 0 } ] }>
                <View key="title" style={ [
                    styles.leftColumn,
                    {
                        width: "30%",
                        justifyContent: "flex-end",
                        alignItems: "flex-end"
                    }
                ] }>
                    <Text style={ [
                        styles.textStart,
                        {
                            fontFamily: "Verdana, sans-serif",
                            fontSize: "9px",
                            margin: 0,
                            color: "#009999",
                            marginTop: 4,
                            textAlign: "right",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            display: "flex"
                        }
                    ] }>
                        COMPETENCES
                    </Text>
                </View>
                <View key="line" style={ [
                    styles.rightColumn,
                    {
                        width: "70%",
                        justifyContent: "flex-end",
                        alignItems: "flex-end"
                    }
                ] }>
                    <View style={ {
                        width: "100%",
                        height: 5,
                        backgroundColor: "#009999",
                        marginVertical: 4
                    } }/>
                </View>
            </View>
            <View key="content" style={ [ styles.section, { marginBottom: 0, marginTop: 10 } ] }>
                <View key="sub-title" style={ [
                    styles.leftColumn,
                    {
                        width: "30%",
                        justifyContent: "flex-start",
                        alignItems: "flex-end"
                    }
                ] }>
                    <Text style={ [
                        styles.textStart,
                        {
                            fontFamily: "Verdana, sans-serif",
                            fontSize: "9px",
                            margin: 0,
                            color: "#009999",
                            marginTop: 4,
                            textAlign: "right",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            display: "flex"
                        }
                    ] }>
                        Compétences techniques
                    </Text>
                </View>
                <View key="list" style={ [
                    styles.rightColumn, {
                        width: "70%",
                        justifyContent: "flex-end",
                        alignItems: "flex-start"
                    }
                ] }>
                    { businessSkills
                        .map( ( category, index ) => (
                            <View key={ index } style={ { display: "flex", flexDirection: "column", gap: 4 } }>
                                { category.competences.map( ( competence, subIndex ) => (
                                    <View key={ subIndex }>
                                        <Text style={ [ styles.textStart, {
                                            fontSize: "9px",
                                            fontFamily: "Verdana, sans-serif",
                                            color: "#3F3A38"
                                        } ] }>
                                            -{ ' ' }
                                            { competence.translations[ documentLanguage ] }
                                            { ' ' }
                                            { competence.level <= 2
                                                ? '(1)'
                                                : competence.level > 2 && competence.level <= 4
                                                    ? '(2)'
                                                    : '(3)'
                                            }
                                        </Text>
                                    </View>
                                ) ) }
                            </View>
                        ) ) }
                </View>
            </View>
        </>
    );
}
